<template>
  <div
    class="mc-videohistory-stream__state mc-videohistory-stream__state--video"
    :class="{ 'fill-screen': isFill }"
  >
    <video-stream-player
      v-if="isVideoDemo && readyState"
      :ref="`videoPlayerDemo${source.id}`"
      class="vjs-custom-skin"
      :src="source.src"
      :playerId="`${source.id}`"
      crossorigin="anonymous"
      @ready="onInPlayerDemoReady()"
      @ended="onEndedVideoDemo"
    />
    <video-stream-vss
      v-else-if="isVssHowen"
      :ref="`videoPlayer${source.id}`"
      type="playback"
      :channel="source.channel"
      :start-time="source.startTime"
      :end-time="source.endTime"
      :imei="$store.state.vehicle.vehicleDetail.imei"
      :playlist-id="source.id"
      :default-open-audio="!muted"
      @playbackEnd="onVssEnded"
      @ready="onPlayerVssReady($event)"
      @stop="onPlayerVssStop($event)"
    />
    <video-stream-flv
      v-else
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      :src="source.src"
      :playerId="`${source.id}`"
      :isRecording="isRecording"
      type="playback"
      @ready="onReady"
      @loadeddata="onLoadDataFlv"
      @error="onError"
      @timeupdate="onTimeupdate"
      @pendingTimeout="onPendingTimeout"
    />
    <div class="mc-trackvideo-card--video-action justify-content-between">
      <div>
        <span class="me-3">
          <i
            v-if="$store.state.vehicle.videoState === 'ready'"
            class="mc-fa icon-fill_pause"
            @click="pauseStream()"
          ></i>
          <i
            v-else-if="$store.state.vehicle.videoState === 'pause'"
            class="mc-fa icon-fill_play"
            @click="continueStream()"
          ></i>
        </span>
        <span>
          <i v-if="!muted" class="mc-fa icon-outline_volume-up" @click="muteVideo"></i>
          <i v-else class="mc-fa icon-outline_volume-off" @click="muteVideo"></i>
        </span>
      </div>

      <div>
        <span class="me-3" @click="toggleFillFit()">
          <i v-show="isFill" class="mc-fa icon-fill_fit-screen"></i>
          <i v-show="!isFill" class="mc-fa icon-fill_fill-screen"></i>
        </span>
        <span @click="detailVideo()">
          <i class="mc-fa icon-fill_fullscreen"></i>
          <i class="mc-fa icon-fill_exit-fullscreen"></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import VideoStreamFlv from '@/components/Video/VideoStreamFlv.vue'
import VideoStreamPlayer from '@/components/Video/VideoStreamPlayer.vue'
import VideoStreamVss from '@/components/Video/VideoStreamVss.vue'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import moment from 'moment'
import { mapGetters } from 'vuex'

moment.locale('id')

export default {
  components: {
    VideoStreamFlv,
    VideoStreamPlayer,
    VideoStreamVss,
  },

  mixins: [Helper, MixPanel],

  props: {
    source: {
      type: Object,
      required: true,
    },
    isMdvrSleep: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      muted: true,

      capturedFrames: [],
      isRecording: false,
      recordInterval: null,
      bandwidth: 0,

      errorState: 0,
      readyState: false,
      maxAttemptsError: 10,
      fullscreen: false,

      // This is for handle timeupdate after connection is abort
      timeoutTimeUpdate: null,
      isFill: false,

      freezeTimeout: null,
      freezeInterval: 3000,

      // for sleep state
      isVideoSleep: false,
      isCountdownSleepEnd: false,
    }
  },

  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isVideoDemo() {
      if (!this.$route.query?.vehicleId) return false
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.query?.vehicleId.toString())
    },
    isVssHowen() {
      return this.$store.state.vehicle.vehicleDetail.deviceName === 'vss-howen'
    },
  },

  watch: {
    '$store.state.vehicle.source': {
      async handler(source) {
        if (this.isVssHowen) {
          this.readyState = false
        }
        if (this.isVideoDemo) {
          this.readyState = false
          await this.delay(100)
          this.readyState = true
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    window.addEventListener('popstate', (event) => {
      if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
        document.body.classList.remove('mc-trackvideo-fullscreen--detail')
      }
    })
    document.addEventListener('fullscreenchange', (event) => {
      const isExitFullscreen = document.fullscreenElement === null
      if (isExitFullscreen) {
        if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
          document.body.classList.remove('mc-trackvideo-fullscreen--detail')
        }
      }
    })
  },

  methods: {
    onEndedVideoDemo() {
      this.$store.commit('vehicle/setVideoStatusDetail', 'ended')
    },
    onInPlayerDemoReady() {
      var refsName = `videoPlayerDemo${this.source.id}`
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },

    pauseStream() {
      this.track('Stop Streaming Video History')
      if (this.$store.state.vehicle.videoState === 'ready') {
        if (this.isVssHowen) {
          this.$refs[`videoPlayer${this.source.id}`].pausePlayback()
        }

        this.$store.commit('vehicle/setVideoStatusDetail', 'pause')
        this.$store.commit('vehicle/setIsVideoHasBeenPaused', true)
      }
    },

    continueStream() {
      if (this.$store.state.vehicle.videoState === 'pause') {
        if (this.isVssHowen) {
          this.$refs[`videoPlayer${this.source.id}`].resumePlayback()
        }

        this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
      }
    },

    onVssEnded() {
      this.$store.commit('vehicle/setSource', null)
      this.$store.commit('vehicle/setVideoStatusDetail', 'ended')
    },

    async detailVideo() {
      document.body.classList.toggle('mc-trackvideo-fullscreen--detail')
      await this.$nextTick()
      if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
        var elem = document.documentElement

        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen()
        }
      }
    },

    onReady() {
      if (this.$store.state.vehicle.videoState === 'connecting') {
        this.$emit('startPlay')
      }
      if (this.isVideoSleep) {
        this.isVideoSleep = false
        this.isCoundownSleepEnd = false
      }
      this.errorState = 0
      this.readyState = true
      this.$emit('ready')
    },

    onLoadDataFlv(data, bandwidth) {
      this.bandwidth = bandwidth
      this.$emit('load')
    },

    countdownSleepEnd() {
      this.isVideoSleep = false
      this.isCoundownSleepEnd = true
      this.errorState = 0
    },

    onError() {
      const deviceType = this.$store.state.vehicle.vehicleDetail.deviceName

      const videoActive =
        this.$store.state.vehicle.vehicleVideos[this.$store.state.vehicle.indexVideoActive[0]]
          .videos[this.$store.state.vehicle.indexVideoActive[1]]

      if (this.isCoundownSleepEnd) {
        this.isCoundownSleepEnd = false
        return
      }

      if (this.isVideoSleep) {
        this.reinitPlayerWhenSleep()
        return
      }

      this.isCountdownSleepEnd = false

      if (deviceType === 'jc') {
        videoActive.endTime = this.momentAdd(videoActive.startTime, 1, 'minute')
      }

      const diffSeconds = moment(videoActive.endTime).diff(moment(videoActive.startTime), 'seconds')

      const tolerance = 4

      if (this.$store.state.vehicle.timePlaybackActive >= diffSeconds - tolerance) {
        this.$store.commit('vehicle/setVideoStatusDetail', 'ended')
        return
      }

      if (this.readyState) {
        if (
          this.$store.state.vehicle.videoState === 'pause' ||
          (this.$store.state.vehicle.isVideoHasBeenPaused &&
            this.$store.state.vehicle.videoState === 'ready')
        ) {
          const streamPlayerComponent = this.$refs[`videoPlayer${this.source.id}`]

          let lastTime = 0
          let stalledCount = 0

          streamPlayerComponent.player.addEventListener('timeupdate', () => {
            if (streamPlayerComponent.player.currentTime === lastTime) {
              // Increment stalled counter if time hasn't progressed
              stalledCount++
            } else {
              // Reset stalled counter if time has progressed
              stalledCount = 0
            }

            // Check if the video has effectively stopped
            if (stalledCount > 0 && this.$store.state.vehicle.isVideoHasBeenPaused) {
              // Video has been stopped
              // eslint-disable-next-line no-console
              console.log('Video has been stopped or stalled.')
              if (streamPlayerComponent.player.currentTime >= diffSeconds - tolerance) {
                this.$store.commit('vehicle/setVideoStatusDetail', 'ended')
              } else {
                this.$store.commit('vehicle/setVideoStatusDetail', 'error')
              }
            }

            // Update lastTime for the next check
            lastTime = streamPlayerComponent.player.currentTime
          })
          return
        }
        this.$store.commit('vehicle/setVideoStatusDetail', 'connecting')
        this.errorState = 0
        this.readyState = false
      }

      const maxAttempts = this.maxAttemptsError
      if (this.errorState >= maxAttempts) {
        this.errorState = 0
        if (this.isMdvrSleep) {
          this.$emit('sleep')
          this.isVideoSleep = true
          this.isCoundownSleepEnd = false
          this.reinitPlayerWhenSleep()
        } else {
          this.$emit('error')
        }
        return
      }

      setTimeout(() => {
        this.$refs[`videoPlayer${this.source.id}`].initialize()
        this.errorState++
      }, 1000)
    },

    reinitPlayerWhenSleep() {
      setTimeout(() => {
        this.$refs[`videoPlayer${this.source.id}`].initialize()
      }, 1000)
    },

    onTimeupdate(event) {
      this.$store.commit('vehicle/setTimePlaybackActive', event.srcElement.currentTime)
      this.resetFreezeTimer()
    },

    resetFreezeTimer() {
      if (this.freezeTimeout) {
        clearTimeout(this.freezeTimeout)
      }
      this.freezeTimeout = setTimeout(() => {
        this.onFreeze()
      }, this.freezeInterval)
    },

    onFreeze() {
      this.checkEndedVideo()
    },

    // handler event when player freeze
    onPendingTimeout() {
      if (this.isVideoDemo) return
      if (this.isVideoSleep) return

      clearTimeout(this.freezeTimeout)
      clearTimeout(this.timeoutTimeUpdate)
      this.errorState = 0
      this.$emit('error')
      this.$forceUpdate()
    },

    checkEndedVideo() {
      const deviceType = this.$store.state.vehicle.vehicleDetail.deviceName
      const videoActive =
        this.$store.state.vehicle.vehicleVideos[this.$store.state.vehicle.indexVideoActive[0]]
          .videos[this.$store.state.vehicle.indexVideoActive[1]]

      if (deviceType === 'jc') {
        videoActive.endTime = this.momentAdd(videoActive.startTime, 1, 'minute')
      }

      const diffSeconds = moment(videoActive.endTime).diff(moment(videoActive.startTime), 'seconds')

      const tolerance = 4
      if (this.$store.state.vehicle.timePlaybackActive >= diffSeconds - tolerance) {
        this.$store.commit('vehicle/setVideoStatusDetail', 'ended')
        return true
      }
      return false
    },

    pauseVideo() {
      this.$emit('pause')
    },

    async muteVideo() {
      this.muted = !this.muted
      await this.$nextTick()
      if (this.isVssHowen) {
        this.$refs[`videoPlayer${this.source.id}`].setOpenAudio(!this.muted)
      } else {
        this.$emit('mute')
      }
    },

    captureImage() {
      const ref = this.$refs[`videoPlayer${this.source.id}`]

      const canvas = document.createElement('canvas')
      canvas.width = ref.player.videoWidth
      canvas.height = ref.player.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(ref.player, 0, 0, canvas.width, canvas.height)
      const dataURL = canvas.toDataURL('image/png') // Convert canvas to data URL

      const a = document.createElement('a')
      a.href = dataURL
      a.download = `${this.source.licensePlate}-${this.source.channel}_${this.momentYmDHms(
        new Date()
      )}.png` // Set the filename for the downloaded image
      a.click()
    },
    toggleFillFit() {
      this.isFill = !this.isFill
    },

    onPlayerVssReady(event) {
      this.readyState = true
      this.$emit('ready')
    },
    async onPlayerVssStop(event) {
      await this.$nextTick()
      if (this.readyState) {
        this.$emit('error')
      }
      this.readyState = false
    },
  },
}
</script>
